import { useMemo } from "react";
import moment, { type Moment } from "moment-timezone";
import { useFilters } from "../../../../../utils/hooks/useFilters";
// import { weekdays } from "@/components/inputs/WeekdayBadgeSelect";

export interface GridDates {
    gridDates: string[];
    gridStartTime: Moment;
    gridEndTime: Moment;
}

export const useGridDates = (): GridDates => {
    const [{ from, to, mode }] = useFilters();

    const gridDates = useMemo(() => {
        const dates: string[] = [];
        const addDatesByInterval = (start: Moment, end: Moment, unit: moment.DurationInputArg2, format: string) => {
            while (start.isSameOrBefore(end, unit)) {
                dates.push(start.format(format));
                start.add(1, unit);
            }
        };
        switch (mode) {
            default:
            case "day": {
                // const startOfThisWeek = moment().startOf("week");
                // const dayIndex = weekdays.indexOf(day);
                // const start = ["team", "home"].includes(type) ? moment(from).startOf("day") : startOfThisWeek.clone().day(dayIndex).startOf("day");
                // const end = ["team", "home"].includes(type) ? moment(from).endOf("day") : startOfThisWeek.clone().day(dayIndex).endOf("day");
                const start = moment(from).startOf("day")
                const end = moment(from).endOf("day")
                addDatesByInterval(start, end, "hour", "YYYY-MM-DD HH:00:00");
                break;
            }
            case "week":
            case "month": {
                const start = moment(from).startOf(mode);
                const end = moment(from).endOf(mode);
                addDatesByInterval(start, end, "day", "YYYY-MM-DD");
                break;
            }
            case "pay-group":
            case "custom": {
                const start = moment(from).startOf("day");
                const end = moment(to).startOf("day");
                addDatesByInterval(start, end, "day", "YYYY-MM-DD");
                break;
            }
        }
        return dates;
    }, [from, to, mode]);

    const { gridStartTime, gridEndTime } = useMemo(() => {
        const endof = mode === "day" ? "hour" : "day";
        return {
            gridStartTime: moment(gridDates[0]),
            gridEndTime: moment(gridDates[gridDates.length - 1]).endOf(endof),
        };
    }, [gridDates, mode]);

    return { gridDates, gridStartTime, gridEndTime };
};
